import { defineMessages } from 'react-intl';

export default defineMessages({
  numContract: {
    id: 'dashboard_EPARGN.mes_contracts.num_contract',
  },
  dateEffet: {
    id: 'auto_details.my_contracts.date_effet',
  },
  souscripteur: {
    id: 'mrh_details.my_contracts.souscripteur',
  },
  EpargnBrute: {
    id: 'epargn_detail.epargn_brute',
  },
  membershipNumber: {
    id: 'epargn_detail.membership_number',
  },
  ppr: {
    id: 'epargn_detail.ppr',
  },
  capitalGaranti: {
    id: 'releve_situation.epargn_capital_garanti',
  },
});
